import { Injectable } from '@angular/core';
import { ApiService } from '../API/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AllergenService {

  constructor(public apiService: ApiService) { }

  getAllergen(body : any): Observable<any> {
    return this.apiService.post('allergen/getAllergens', body)
  }
 addAllergen(body : any): Observable<any> {
    return this.apiService.post('allergen/createAllergen', body)
  }
  editAllergen(body : any): Observable<any> {
    return this.apiService.post('allergen/editAllergen', body)
  }
}
